import React, { useContext, useState } from "react";
import { TableHead, TextField, Button } from "@mui/material";
import blogFetch from "../../../axios/config";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { remove0fromLeft } from "../../../utils/DataUtils";
import language from '../../../nls/language.json';
import Context from "../../../context/Context";

function SalesOrders(props) {
  const {
    selectedCountry,
  } = useContext(Context);

  const style = {
    padding: 0.6,
    textAlign: "center",
    whiteSpace: "nowrap",
  };
  const getHeader = async (order) => {
    try {
      const response = await blogFetch.get(`/SAGAViewFichaCabecalho/${order}`);
      const header = response.data[0];
      if (header) {
        props.setCode(header);
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  if (props.sagA_SalesOrders[0]) {
    props.setToolTipText(
      props.sagA_SalesOrders[0].pedido_Genesis +
        ";" +
        props.sagA_SalesOrders[0].pedido
    );
  }

  return (
    <TableContainer component={Paper} sx={{ overflow: "auto" }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pedido.tableHeader.ordemSerial}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pedido.tableHeader.peca}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pedido.tableHeader.material}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pedido.tableHeader.lote}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pedido.tableHeader.setor}</TableCell>
            <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pedido.tableHeader.statusProd}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!!props.sagA_SalesOrders &&
            props.sagA_SalesOrders.map((eachObj, index) => (
              <TableRow>
                <TableCell sx={style}>
                  <Button
                    onClick={async () => {
                      await getHeader(eachObj.ordem);
                    }}
                  >
                    {eachObj.ordem}
                  </Button>{" "}
                </TableCell>
                <TableCell sx={style}>
                  {eachObj.cod_Peca} - {eachObj.part_Short}{" "}
                </TableCell>
                <TableCell sx={style}>
                  {remove0fromLeft(eachObj.material)}{" "}
                </TableCell>

                <TableCell sx={style}>{eachObj.lote} </TableCell>
                <TableCell sx={style}>{eachObj.setor} </TableCell>
                <TableCell sx={style}>{eachObj.status_Prod} </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SalesOrders;
